/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-thin-left': {
    width: 18,
    height: 32,
    viewBox: '0 0 18 32',
    data: '<path pid="0" d="M16.063 31.969a1.086 1.086 0 01-.641-.217l-.11-.096-15-15.031a1.023 1.023 0 01-.312-.75c0-.243.072-.457.217-.642l.096-.108L15.092.312c.21-.208.464-.312.766-.312s.558.104.766.313c.208.208.313.463.313.765 0 .252-.073.471-.218.658l-.095.108L2.562 15.875l14.282 14.281c.208.209.312.459.312.75 0 .292-.104.542-.312.75a1.022 1.022 0 01-.36.235 1.165 1.165 0 01-.422.078z" _fill="#000" fill-rule="nonzero"/>'
  }
})
